import type { ConsoleNavGroup, ConsoleNavItem } from '../components/layout/console-sidebar';

export type ConsoleSegmentTitleMaps = Record<string, Record<string, string>>;

type ResolveConsoleRouteTitleOptions = {
  extras?: Array<Pick<ConsoleNavItem, 'label' | 'href'>>;
  segmentTitleMaps?: ConsoleSegmentTitleMaps;
  fallback?: string;
};

export function resolveConsoleRouteTitle(
  pathname: string,
  topNav: ConsoleNavItem[],
  groups: ConsoleNavGroup[],
  options?: ResolveConsoleRouteTitleOptions,
): string {
  const allItems: Array<Pick<ConsoleNavItem, 'label' | 'href'>> = [
    ...topNav,
    ...groups.flatMap((group) => group.items),
    ...(options?.extras ?? []),
  ];

  const direct = allItems.find((item) => item.href === pathname);
  if (direct) return direct.label;

  const prefixMatch = allItems
    .filter((item) => pathname === item.href || pathname.startsWith(`${item.href}/`))
    .sort((a, b) => b.href.length - a.href.length)[0];
  if (prefixMatch) return prefixMatch.label;

  const segments = pathname.split('/').filter(Boolean);
  if (options?.segmentTitleMaps) {
    if (segments.length === 2) {
      const [section, slug] = segments;
      const segmentTitle = options.segmentTitleMaps[section]?.[slug];
      if (segmentTitle) return segmentTitle;
    }
    if (segments.length === 3 && segments[0] === 'circles') {
      const sectionTitle = options.segmentTitleMaps.circles?.[segments[2]!];
      if (sectionTitle) return sectionTitle;
    }
  }

  return options?.fallback ?? 'Dashboard';
}
